import { connect, useDispatch } from "react-redux";
import { IStudentFinancialAssistance } from "../../../../models/student/studentAccountsDetails";
import { useEffect, useState } from "react";
import { setDescriptionText } from "../../../../store/slices/common/commonSlice";
import { pageBlockId } from "../../../../constants/pageBlocks";
import { getDescriptionText } from "../../../../action/common/commonActionCreator";
import ReactModal from "react-modal";
import FinancialAssistanceCompose from "./financialAssistanceCompose";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";
import { baseURL } from "../../../../constants/commonConstants";

const StudentFinacialAssistance = (props: IStudentFinancialAssistance) => {
  const { getDescriptionText, description, snapShots } = props;
  const dispatch = useDispatch();
  const [showCompose, setShowCompose] = useState<boolean>(false);
  const handleOpenModal = () => setShowCompose(true);
  const handleCloseModal = () => setShowCompose(false);
  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.financialAssistance
  );

  useEffect(() => {
    getDescriptionText(pageBlockId.financialAssistance);
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setDescriptionText([]));
    };
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div
          className="img w-100 d-flex align-item-center"
          style={{ height: "150px", overflow: "hidden" }}
        >
          {pageBlockData?.displayOrNot && (
            <img className="m-auto" src="/assets/images/emailbot.svg" alt="" />
          )}
        </div>
        <div className="desc text-left mt-2">
          <h2 className="para-hide-1 mb-2">Financial Assistance</h2>
          {pageBlockData?.displayOrNot && description && (
            <>
              <p className="para-hide-2">{description?.description}</p>
              <button
                className="btn btn-primary m-auto mt-3 w-150"
                onClick={handleOpenModal}
              >
                Connect
              </button>
            </>
          )}
        </div>
      </div>
      <ReactModal
        isOpen={showCompose}
        onRequestClose={handleCloseModal}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <FinancialAssistanceCompose setShowCompose={handleCloseModal} />
      </ReactModal>
    </>
  );
};

const mapDispatchToProps = {
  getDescriptionText: (pageBlockId: number) => getDescriptionText(pageBlockId),
};

function mapStateToProps(state: any) {
  return {
    description: state.common.descriptionText,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentFinacialAssistance);
